// extracted by mini-css-extract-plugin
export var button = "button-module--button--fD36P";
export var isActive = "button-module--is-active--sr2xx";
export var isBlue = "button-module--is-blue--4vZkf";
export var isFocused = "button-module--is-focused--951LV";
export var isPink = "button-module--is-pink--GQ7qS";
export var isSmall = "button-module--is-small--rMrYM";
export var isYellow = "button-module--is-yellow--cJUSu";
export var outlined = "button-module--outlined--s4h-h";